/**
 * Find the closest anchor element from the event target.
 * This handles cases where the click might be on a child of the anchor,
 * such as when bold text contains a link.
 */
export const findAnchorElement = (element: EventTarget | null): HTMLAnchorElement | null => {
    if (!element || !(element instanceof Element)) return null;
    return element.closest('a') as HTMLAnchorElement | null;
};
